import React from "react";
import { isAuthenticated } from "utils/common";

function Company() {
  return (
    <div className={isAuthenticated() ? "w-80" : "container px-3 px-lg-0"}>
      <div className="fs-20 fs-sm-18 fw-600 sp-14 text-center py-3 py-md-4">
        運営会社
      </div>
      <div className="mx-3 mx-md-0 mt-2">
        <table className="table company border-black text-black border-radius-5 w-100">
          <tbody>
            <tr>
              <td>社名</td>
              <td>株式会社アーキテクト</td>
            </tr>
            <tr>
              <td>所在地</td>
              <td>
                〒105－0012 
                <br /> 東京都港区芝大門二丁目11番8号
                <br /> 住友不動産芝大門二丁目ビル 8F   
              </td>
            </tr>
            <tr>
              <td>資本金</td>
              <td>1億円</td>
            </tr>
            <tr>
              <td>設立年月日</td>
              <td>2015年8月3日</td>
            </tr>
            <tr>
              <td>事業内容</td>
              <td>
                マーケティングリサーチの企画・実施 <br />
                トータルマーケティングのコンサルテーション
                <br />
                販売支援
                <br />
                人材マネジメント
                <br />
                ブランドマネジメント
                <br />
                リクルーティング
                <br />
                各種人的動員・人材派遣
                <br />
                映像事業に関する企画・制作
                <br />
                セールスプロモーション事業やイベントの企画立案、制作、実施までの業務
                <br />
                総合音楽出版事業
              </td>
            </tr>
            <tr>
              <td>加盟団体</td>
              <td>一般社団法人日本マーケティング・リサーチ協会</td>
            </tr>
            <tr>
              <td>地名・番地</td>
              <td>一般労働者派遣許可番号 般13-040223</td>
            </tr>
            <tr>
              <td>ホームページ</td>
              <td>
                <a href={"https://www.architect.co.jp/"}>
                  https://www.architect.co.jp/
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Company;
